import React, { useEffect, useRef } from 'react';

// eslint-disable-next-line import/no-unresolved
import { useDrag, useDrop } from 'react-dnd';

const ItemTypes = {
  CARD: 'card',
};

export const Card = ({
  id,
  text,
  index,
  moveCard,
  generalIsDragging,
  setIsDragging,
  handleArrowUp,
  handleArrowDown,
  handleRemoveFromList,
}) => {
  const ref = useRef(null);

  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    setIsDragging(isDragging);
  }, [isDragging]);
  const handleArrowUpCard = () => {
    handleArrowUp(id);
  };
  const handleArrowDownCard = () => {
    handleArrowDown(id);
  };
  const handleRemoveCard = () => {
    handleRemoveFromList(id);
  };
  const opacity = isDragging ? 0.5 : 1;
  const display = isDragging ? 'none' : 'block';
  const cursor = generalIsDragging ? 'grabbing' : 'grab';
  const cardDraging = isDragging
    ? 'quick-access-card draggable-cursor'
    : 'quick-access-card';
  drag(drop(ref));
  return (
    <div
      className={cardDraging}
      ref={ref}
      style={{ opacity, cursor }}
      data-handler-id={handlerId}
    >
      <div className="quick-access-card-arrows">
        <i className="quick-access-card-arrow-up" onClick={handleArrowUpCard} />
        <i
          className="quick-access-card-arrow-down"
          onClick={handleArrowDownCard}
        />
      </div>
      <div className="quick-access-card-text" title={text}>
        {text.length > 25 ? `${text.substring(0, 24)}...` : text}
      </div>
      <div className="quick-access-card-delete-img">
        <img
          src="/assets/images/icons/icon_delete_document.svg"
          onClick={handleRemoveCard}
          style={{ display }}
          alt="remover card"
        />
      </div>
    </div>
  );
};
